import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-control",
  "use": "icon-th-control-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-control\">\n<path d=\"M25.7076 15.7076C25.6147 15.8005 25.5044 15.8743 25.383 15.9246C25.2616 15.9749 25.1315 16.0008 25.0001 16.0008C24.8687 16.0008 24.7385 15.9749 24.6171 15.9246C24.4957 15.8743 24.3854 15.8005 24.2926 15.7076L16.0001 7.4138L7.70757 15.7076C7.51993 15.8952 7.26543 16.0006 7.00007 16.0006C6.7347 16.0006 6.48021 15.8952 6.29257 15.7076C6.10493 15.5199 5.99951 15.2654 5.99951 15.0001C5.99951 14.7347 6.10493 14.4802 6.29257 14.2926L15.2926 5.29255C15.3854 5.19958 15.4957 5.12582 15.6171 5.07549C15.7385 5.02517 15.8687 4.99927 16.0001 4.99927C16.1315 4.99927 16.2616 5.02517 16.383 5.07549C16.5044 5.12582 16.6147 5.19958 16.7076 5.29255L25.7076 14.2926C25.8005 14.3854 25.8743 14.4957 25.9246 14.6171C25.975 14.7385 26.0009 14.8686 26.0009 15.0001C26.0009 15.1315 25.975 15.2616 25.9246 15.383C25.8743 15.5044 25.8005 15.6147 25.7076 15.7076Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-control.svg
// module id = 4wK9
// module chunks = 84